import {
  LuShieldCheck,
  LuClipboardCheck,
  LuCheck,
  LuMapPin,
  LuFileText,
} from "react-icons/lu";
import { business, serviceAreas } from "../../content/site";

/**
 * TrustBar
 *
 * A narrow band of reassurance directly under the hero.
 *
 * Every item here must be a claim the business can defend today. Deliberately
 * ABSENT until the owner confirms them: same-day service, 24/7 emergency
 * availability, background-checked technicians, star ratings, and years in
 * business. None of those facts exist in site.js, so none of them render.
 */
const TrustBar = () => {
  const items = [
    {
      id: "licensed",
      Icon: LuShieldCheck,
      label: "Licensed and insured electricians",
    },
    {
      id: "pricing",
      Icon: LuClipboardCheck,
      label: "Upfront pricing before work starts",
    },
    {
      id: "code",
      Icon: LuCheck,
      label: "Code-compliant work",
    },
    {
      id: "area",
      Icon: LuMapPin,
      label: serviceAreas.shortLabel,
    },
  ];

  /*
    The license number is the cheapest, highest-trust element available, and
    both reference sites under-use it. It is `null` in site.js until the owner
    supplies the Texas TECL number, so this item simply does not render yet.
  */
  if (business.licenseNumber) {
    items.push({
      id: "license-number",
      Icon: LuFileText,
      label: `License ${business.licenseNumber}`,
    });
  }

  /*
    Column count follows the item count so the row never ends with an empty
    cell when the license number is not yet available.
  */
  const columnClass =
    items.length >= 5 ? "md:grid-cols-3 lg:grid-cols-5" : "md:grid-cols-4";

  return (
    <section
      aria-labelledby="trust-bar-heading"
      className="relative border-b border-line bg-surface-sunken"
    >
      <div className="container-page py-6 sm:py-8">
        <h2 id="trust-bar-heading" className="sr-only">
          What you can count on
        </h2>

        <ul className={`grid grid-cols-2 gap-x-4 gap-y-5 ${columnClass}`}>
          {items.map(({ id, Icon, label }) => (
            <li
              key={id}
              className="flex min-w-0 items-start gap-3 text-body-sm text-ink-muted"
            >
              <Icon
                aria-hidden="true"
                className="mt-0.5 h-5 w-5 shrink-0 text-ink-brand"
              />
              <span className="min-w-0 [overflow-wrap:anywhere]">{label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default TrustBar;
